function wmPopupIsIos() {
  var ua = navigator.userAgent || '';
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function wmPopupIsAndroid() {
  return /Android/i.test(navigator.userAgent || '');
}

function wmPopupNavigate(url, newTab) {
  if (!url) return;
  if (newTab) {
    window.open(url, '_blank', 'noopener');
    return;
  }
  window.location.href = url;
}

function wmSetupSpecialPopup(popup) {
  if (!popup || popup.dataset.wmPopupReady === '1') return;
  popup.dataset.wmPopupReady = '1';

  var primaryBtn = popup.querySelector('[data-wm-smart-download="1"]');
  var backBtn = popup.querySelector('[data-wm-popup-back="1"]');
  var qrScreen = popup.querySelector('.wm-special-popup__screen--qr');
  var iosUrl = popup.dataset.iosUrl || '';
  var androidUrl = popup.dataset.androidUrl || '';

  function showMain() {
    popup.classList.remove('is-showing-qr');
  }

  function showQr() {
    if (!qrScreen) return;
    popup.classList.add('is-showing-qr');
  }

  if (primaryBtn) {
    primaryBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (wmPopupIsIos() && iosUrl) {
        wmPopupNavigate(iosUrl, primaryBtn.target === '_blank');
        return;
      }

      if (wmPopupIsAndroid() && androidUrl) {
        wmPopupNavigate(androidUrl, primaryBtn.target === '_blank');
        return;
      }

      if (qrScreen) {
        showQr();
        return;
      }

      wmPopupNavigate(primaryBtn.getAttribute('href'), primaryBtn.target === '_blank');
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showMain();
    });
  }
}

window.wmBuildSpecialPopupContent = function(inner, sc, desktopImg, mobileImg) {
  var hasPrimaryPopupCta = !!(
    sc.cta_text && (sc.cta_url || sc.ios_cta_url || sc.android_cta_url)
  );
  var hasSecondaryPopupCta = !!(sc.secondary_cta_url && sc.secondary_cta_text);

  var popup = document.createElement('div');
  popup.className = 'wm-special-popup';
  popup.dataset.iosUrl = sc.ios_cta_url || '';
  popup.dataset.androidUrl = sc.android_cta_url || '';
  popup.dataset.qrBackText = sc.qr_back_text || 'Back';

  var track = document.createElement('div');
  track.className = 'wm-special-popup__track';

  var mainScreen = document.createElement('div');
  mainScreen.className = 'wm-special-popup__screen wm-special-popup__screen--main';

  if (desktopImg) {
    var picture = document.createElement('picture');
    picture.className = 'wm-special-popup__artwork';

    if (mobileImg) {
      var source = document.createElement('source');
      source.setAttribute('media', '(max-width: 767px)');
      source.setAttribute('srcset', mobileImg);
      picture.appendChild(source);
    }

    var img = document.createElement('img');
    img.className = 'wm-special-popup__image';
    img.src = desktopImg;
    img.alt = sc.alt || 'Wax Merchant';
    img.loading = 'lazy';
    picture.appendChild(img);

    mainScreen.appendChild(picture);
  }

  if (hasPrimaryPopupCta || hasSecondaryPopupCta) {
    var buttons = document.createElement('div');
    buttons.className = 'wm-special-popup__buttons';

    if (hasPrimaryPopupCta) {
      var primaryBtn = document.createElement('a');
      primaryBtn.className = 'wm-special-popup__button wm-special-popup__button--primary';
      primaryBtn.href = sc.cta_url || sc.ios_cta_url || sc.android_cta_url;
      primaryBtn.textContent = sc.cta_text;
      primaryBtn.dataset.wmSmartDownload = '1';

      if (sc.cta_new_tab) {
        primaryBtn.target = '_blank';
        primaryBtn.rel = 'noopener';
      }

      primaryBtn.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      buttons.appendChild(primaryBtn);
    }

    if (hasSecondaryPopupCta) {
      var secondaryBtn = document.createElement('a');
      secondaryBtn.className = 'wm-special-popup__button wm-special-popup__button--secondary';
      secondaryBtn.href = sc.secondary_cta_url;
      secondaryBtn.textContent = sc.secondary_cta_text;

      if (sc.secondary_cta_new_tab) {
        secondaryBtn.target = '_blank';
        secondaryBtn.rel = 'noopener';
      }

      secondaryBtn.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      buttons.appendChild(secondaryBtn);
    }

    mainScreen.appendChild(buttons);
  }

  track.appendChild(mainScreen);

  if (sc.qr_image) {
    var qrScreen = document.createElement('div');
    qrScreen.className = 'wm-special-popup__screen wm-special-popup__screen--qr';

    var qrImg = document.createElement('img');
    qrImg.className = 'wm-special-popup__image wm-special-popup__image--qr';
    qrImg.src = sc.qr_image;
    qrImg.alt = sc.alt || 'Wax Merchant';
    qrImg.loading = 'lazy';
    qrScreen.appendChild(qrImg);

    var qrButtons = document.createElement('div');
    qrButtons.className = 'wm-special-popup__buttons wm-special-popup__buttons--single';

    var backBtn = document.createElement('button');
    backBtn.type = 'button';
    backBtn.className = 'wm-special-popup__button wm-special-popup__button--secondary';
    backBtn.dataset.wmPopupBack = '1';
    backBtn.textContent = sc.qr_back_text || 'Back';
    qrButtons.appendChild(backBtn);

    qrScreen.appendChild(qrButtons);
    track.appendChild(qrScreen);
  }

  popup.appendChild(track);
  inner.appendChild(popup);
  wmSetupSpecialPopup(popup);
};

window.wmInitSpecialPopups = function(scope) {
  (scope || document).querySelectorAll('.wm-special-popup').forEach(wmSetupSpecialPopup);
};

document.addEventListener('DOMContentLoaded', function () {
  window.wmInitSpecialPopups(document);
});
